function toBase64Utf8(text) {
  // btoa expects Latin-1; this ensures UTF-8 safety.
  return window.btoa(unescape(encodeURIComponent(text)))
}

let cachedBootstrapCssDataUrl = null

function buildDataUrlFromCss(cssText) {
  return `data:text/css;base64,${toBase64Utf8(String(cssText ?? ""))}`
}

export async function getBootstrapCssDataUrl() {
  if (cachedBootstrapCssDataUrl) {
    return cachedBootstrapCssDataUrl
  }

  const res = await fetch("/bootstrap.min.css")
  if (!res.ok) {
    throw new Error(`Failed to fetch bootstrap css: ${res.status} ${res.statusText}`)
  }
  const cssText = await res.text()
  cachedBootstrapCssDataUrl = buildDataUrlFromCss(cssText)
  return cachedBootstrapCssDataUrl
}
